// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"4fd9a8c2","181":"d1b71139","204":"7121a0e9","220":"2c7d8d76","382":"5bd6fbb1","397":"3d2b4778","418":"923600f4","764":"2c282ab7","787":"7c9af14c","839":"e9f1417e","878":"e360cd27","934":"497dfe9e","937":"286d55ce","997":"6d6b3424"}[chunkId] + ".chunk.js";
};